function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { twMerge } from '@stereoagency/tailwind-config';
import React from 'react';
import { useAccentColors } from '../../hooks';
import { Body, Heading, Label } from '../../atoms';
import ReactConfig from '../../ReactConfig';
export default function BadgeListEntry(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, badge = param.badge, label = param.label, title = param.title, action = param.action, metadata = param.metadata, accentColor = param.accentColor, className = param.className;
    var LinkComponent = ReactConfig.LinkComponent;
    var accentStyle = useAccentColors([
        'colors-badge-list-entry-fg-base',
        accentColor
    ]);
    return /*#__PURE__*/ React.createElement("article", {
        style: accentStyle,
        className: className
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: "grid grid-cols-[auto_1fr] gap-5 items-start sm:block"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex sm:mb-7"
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('rounded-xl text-center px-5 py-6 sm:p-6', variant === 'default' && 'bg-badge-list-entry-fg-base text-badge-list-entry-fg-inverted', variant === 'inverted' && 'bg-badge-list-entry-fg-inverted text-badge-list-entry-fg-base')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "font-heading font-semibold leading-tight text-heading-h2-base sm:text-heading-h2-desktop"
    }, badge.title), /*#__PURE__*/ React.createElement(Body, {
        variant: "sm",
        className: "font-semibold uppercase"
    }, badge.label))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('grid grid-cols-1 grid-flow-row auto-rows-max gap-2 sm:gap-5', variant === 'default' && 'text-badge-list-entry-fg-base', variant === 'inverted' && 'text-badge-list-entry-fg-inverted')
    }, !!label && /*#__PURE__*/ React.createElement(Label, null, label), /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title), !!(metadata === null || metadata === void 0 ? void 0 : metadata.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-2 sm:gap-3"
    }, metadata.map(function(entry) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "entry-".concat(entry.title),
            className: "grid grid-cols-[auto_1fr] gap-4 items-start"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "mt-2"
        }, entry.icon), /*#__PURE__*/ React.createElement(Body, null, entry.title));
    })))));
}

//# sourceMappingURL=BadgeListEntry.js.map